import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'seb-lex-pill',
  templateUrl: './lex-pill.component.html',
  styleUrls: ['./lex-pill.component.css']
})
export class LexPillComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
